import { useMemo, useState } from 'react';
import { panamaHoy, sumarDias } from './costosUtil';

export type PresetKey = 'hoy' | '7d' | '30d' | '60d' | 'custom';

export const PRESETS: Array<{ key: Exclude<PresetKey, 'custom'>; label: string; dias: number }> = [
  { key: 'hoy', label: 'Hoy', dias: 0 },
  { key: '7d', label: 'Últimos 7 días', dias: 6 },
  { key: '30d', label: 'Últimos 30 días', dias: 29 },
  { key: '60d', label: 'Últimos 60 días', dias: 59 },
];

/** Estado del selector de rango (mismo patrón de presets + personalizado de «Uso de IA»). */
export function useRangoFechas(inicial: PresetKey = '30d') {
  const [preset, setPreset] = useState<PresetKey>(inicial);
  const [customStart, setCustomStart] = useState(() => sumarDias(panamaHoy(), -29));
  const [customEnd, setCustomEnd] = useState(() => panamaHoy());

  const { startFecha, endFecha } = useMemo(() => {
    if (preset === 'custom') {
      return customStart <= customEnd
        ? { startFecha: customStart, endFecha: customEnd }
        : { startFecha: customEnd, endFecha: customStart };
    }
    const p = PRESETS.find((x) => x.key === preset)!;
    const end = panamaHoy();
    return { startFecha: sumarDias(end, -p.dias), endFecha: end };
  }, [preset, customStart, customEnd]);

  return { preset, setPreset, customStart, setCustomStart, customEnd, setCustomEnd, startFecha, endFecha };
}

export type RangoFechas = ReturnType<typeof useRangoFechas>;
